import { render, staticRenderFns } from "./EditChapter.vue?vue&type=template&id=22a7df2e&"
import script from "./EditChapter.vue?vue&type=script&lang=js&"
export * from "./EditChapter.vue?vue&type=script&lang=js&"
import style0 from "./EditChapter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports